import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import enCommon from './locales/en/common.json';
import enNav from './locales/en/nav.json';
import enAuth from './locales/en/auth.json';
import enChat from './locales/en/chat.json';

import arCommon from './locales/ar/common.json';
import arNav from './locales/ar/nav.json';
import arAuth from './locales/ar/auth.json';
import arChat from './locales/ar/chat.json';

const resources = {
  en: {
    common: enCommon,
    nav: enNav,
    auth: enAuth,
    chat: enChat,
  },
  ar: {
    common: arCommon,
    nav: arNav,
    auth: arAuth,
    chat: arChat,
  },
};

// Check if a language is stored or default to English
const getInitialLanguage = () => {
  try {
    const stored = localStorage.getItem('app-language');
    if (stored === 'ar' || stored === 'en') return stored;
    // Check if user has preferred_languages with arabic in it
    const prefsRaw = localStorage.getItem('bootstrap_init_data_v2');
    if (prefsRaw) {
      const parsed = JSON.parse(prefsRaw);
      const langs = parsed?.data?.preferences?.preferred_languages;
      if (Array.isArray(langs) && langs.some(l => l.startsWith('ar'))) {
        return 'ar';
      }
    }
  } catch (_) {}
  return 'en';
};

const initialLang = getInitialLanguage();

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    lng: initialLang,
    fallbackLng: 'en',
    supportedLngs: ['en', 'ar'],
    defaultNS: 'common',
    fallbackNS: 'common',
    ns: ['common', 'nav', 'auth', 'chat'],
    load: 'languageOnly',
    detection: {
      order: ['localStorage'],
      lookupLocalStorage: 'app-language',
      caches: ['localStorage'],
    },
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
  });

export default i18n;
